// Project filters and collections. Shared by the site, the prerender script and /admin.
// A project's `categories` (set in /admin) decides which filter pages it appears on.

export const CATEGORIES = [
  { slug: 'shopify', label: 'Shopify', blurb: 'Shopify stores: theme work, Liquid customization, apps and store operations.' },
  { slug: 'wordpress', label: 'WordPress', blurb: 'WordPress websites built with Beaver Builder, Elementor and YOOtheme.' },
  { slug: 'woocommerce', label: 'WooCommerce', blurb: 'WooCommerce stores on WordPress.' },
  { slug: 'bigcommerce', label: 'BigCommerce', blurb: 'BigCommerce store work and catalog management.' },
  { slug: 'e-commerce', label: 'E-commerce', blurb: 'Online stores on Shopify, WooCommerce and BigCommerce.' },
  { slug: 'gohighlevel', label: 'GoHighLevel', blurb: 'GoHighLevel apps, guest hubs, funnels and CRM integrations.' },
  { slug: 'landing-pages', label: 'Landing pages', blurb: 'Conversion-focused landing pages.' },
  { slug: 'government', label: 'Government', blurb: 'Websites and systems for Philippine local government units and public services.' },
  { slug: 'web-apps', label: 'Web apps', blurb: 'Custom web applications in PHP, CakePHP, Laravel and JavaScript.' },
];

export const COLLECTIONS = {
  'guest-hubs': {
    label: 'GoHighLevel Guest Hubs',
    blurb: 'Installable guest apps for RV resorts and campgrounds, built on GoHighLevel: amenities, events, area guide, map, weather and booking in one place.',
    cover: 'hub-stone-mountain-park-campground',   // card image; the iConnect Hub member is a login screen
  },
};

export const categoryBySlug = (slug) => CATEGORIES.find((c) => c.slug === slug);

// Counts per category, for filter chips.
export function categoryCounts(projects) {
  const counts = {};
  for (const p of projects) for (const c of p.categories || []) counts[c] = (counts[c] || 0) + 1;
  return counts;
}

// The "All" view shows one card per collection instead of every member.
export function collapseCollections(projects) {
  const seen = new Set();
  const out = [];
  for (const p of projects) {
    if (!p.collection) { out.push(p); continue; }
    if (seen.has(p.collection)) continue;
    seen.add(p.collection);
    const members = projects.filter((x) => x.collection === p.collection);
    const info = COLLECTIONS[p.collection] || { label: p.collection, blurb: '' };
    out.push({
      ...p, slug: `collection-${p.collection}`, isCollection: true, count: members.length,
      title: `${info.label} (${members.filter((m) => m.status === 'live').length})`, summary: info.blurb, description: info.blurb,
      link: `/projects/${p.collection}`, display_url: `${members.filter((m) => m.status === 'live').length} live hubs`,
      image: (members.find((m) => m.slug === info.cover && m.image) || members.find((m) => m.image && m.slug !== 'iconnect-hub') || {}).image || null,
    });
  }
  return out;
}
